import React from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField"; 
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search"; 
import { inventarioResources } from "../endpoints";
import { DataGrid } from "@mui/x-data-grid";
import SnackbarAlert from "../components/SnackbarAlert";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Tooltip } from "@mui/material";
import DialogEditarPrecioBarra from "../components/DialogEditarPrecioBarra";

class RevisionPrecios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cargando: true,
            datos: [],
            totalFilas: 0,
            openSnack: false,
            severity: null,
            message: null,
            paginationModel: { page: 0, pageSize: 50 },
            searchQuery: "",
            sortModel: [],
            editarPrecioBarra: false,
            filaSeleccionada: null,
        };
        this.searchTimeout = null;
    }

    cargarDatos = () => {
        this.setState({ cargando: true, openSnack: false });
        
        const { page, pageSize } = this.state.paginationModel;
        const { searchQuery, sortModel } = this.state;
        
        let sortField = null;
        let sortDir = "desc"; 
        
        if (sortModel.length > 0) {
            sortField = sortModel[0].field;
            sortDir = sortModel[0].sort;
        }

        inventarioResources.getRevisionPrecios(page, pageSize, searchQuery, sortField, sortDir)
            .then(async response => {
                if (response) return await response.json();
            })
            .then(result => {
                if (result.status_code === 200) {
                    const datosAgrupados = this.procesarDatosParaDataGrid(result.historial);
                    this.setState({ 
                        cargando: false, 
                        datos: datosAgrupados,
                        totalFilas: result.total 
                    });
                } else if (result.status_code === 401) {
                    this.setState({ openSnack: true, cargando: false, severity: result.severity, message: result.message });
                } else {
                    throw new Error('Something went wrong ...');
                }
            })
            .catch(error => {
                console.error(error);
                this.setState({ cargando: false });
            });
    }

    // Mantenemos la data original e intacta para que el ordenamiento sea matemáticamente correcto
    procesarDatosParaDataGrid = (historial) => {
        return historial.map((row, index) => {
            return {
                ...row,
                id: row.id || `${row.articulo}-${row.barra}-${index}`
            };
        });
    };

    componentDidMount() {
        const verifyFolio = useToken.verifyToken();
        if (!verifyFolio) {
            this.props.history.push('/inventarios');
        } else {
            this.cargarDatos();
        }
    }

    handleSearchChange = (event) => {
        const valor = event.target.value;
        this.setState({ searchQuery: valor });

        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.setState({ paginationModel: { ...this.state.paginationModel, page: 0 } }, () => {
                this.cargarDatos();
            });
        }, 600);
    }

    handleClose = () => {
        this.setState({ editarPrecioBarra: false });
    };


    handlePaginationModelChange = (newModel) => {
        this.setState({ paginationModel: newModel }, () => {
            this.cargarDatos();
        });
    }

    handleSortModelChange = (newSortModel) => {
        this.setState({ sortModel: newSortModel }, () => {
            this.cargarDatos();
        });
    }

    refrescar = (estado, severity) => {
        this.setState({
            filaSeleccionada: null,
            editarPrecioBarra: false,
            openSnack: false,
            severity: null,
            message: null

        }, () => {
            if (severity === "success") {
                this.cargarDatos();
            }

            setTimeout(() => {
                this.setState({
                    openSnack: true,
                    severity: severity,
                    message: estado,
                });
            }, 50);
        });
    };


    render() {
        const verifyFolio = useToken.verifyToken();

        if (!verifyFolio) {
            return <Redirect to="/inventarios" />;
        } else {
            // Función auxiliar interna para determinar si ocultamos la celda repetida consecutiva
            const renderCeldaAgrupada = (params) => {
                const api = params.api;
                const rowId = params.id;
                const rows = api.getRowModels();
                const keys = Array.from(rows.keys());
                const currentIndex = keys.indexOf(rowId);

                if (currentIndex > 0) {
                    const prevRowId = keys[currentIndex - 1];
                    const prevRow = api.getRow(prevRowId);
                    
                    // Si el artículo actual es igual al de la fila de ARRIBA, ocultamos el texto visualmente
                    if (prevRow && prevRow.articulo === params.row.articulo) {
                        return "";
                    }
                }
                return params.value;
            };

            const columns = [
                { 
                    field: 'articulo', 
                    headerName: 'Artículo', 
                    minWidth: 200, 
                    sortingOrder: ['asc', 'desc'],
                    renderCell: renderCeldaAgrupada 
                },
                { field: 'barra', headerName: 'Barra', minWidth: 200, sortable: false },
                { field: 'precio_barra', headerName: 'Precio barra', minWidth: 200, type: 'number', sortable: false },
                { 
                    field: 'dif_precio',
                    headerName: 'Dif. Precio', 
                    minWidth: 200, 
                    align: 'right', 
                    headerAlign: 'right', 
                    sortingOrder: ['asc', 'desc'],
                    renderCell: renderCeldaAgrupada
                },
                {
                    field: "acciones",
                    headerName: "Acciones",
                    width: 200,
                    flex: 1,
                    sortable: false,
                    renderCell: (params) => {
            
                    const rowData = params.row;
            
                    return (
                        <div style={{ 
                            display: "flex", 
                            gap: 8, 
                            paddingLeft: "30px", // <--- Ajusta este número (16px, 20px, 32px...) hasta que quede donde te guste
                            alignItems: "center",
                            width: "100%",
                            height: "100%"
                        }}>
                            <Tooltip title="Editar precio">
                                <EditIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        this.setState({ filaSeleccionada: rowData, editarPrecioBarra: true });
                                    }}
                                />
                            </Tooltip>
                        </div>
            
                    );}
                }
                
            ];

            return (
                <div>
                    <Typography variant="h4" gutterBottom>
                        Revisión Precios
                    </Typography>

                    <div style={{ marginBottom: 16, maxWidth: 400 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            placeholder="Buscar artículo o barra..."
                            value={this.state.searchQuery}
                            onChange={this.handleSearchChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGrid
                            rows={this.state.datos}
                            columns={columns}
                            loading={this.state.cargando}
                            disableSelectionOnClick
                            density="compact"
                            disableColumnMenu
                            disableColumnFilter
                            pagination
                            paginationMode="server"
                            sortingMode="server" 
                            rowCount={this.state.totalFilas}
                            sortingOrder={['asc', 'desc']}
                            paginationModel={this.state.paginationModel}
                            onPaginationModelChange={this.handlePaginationModelChange}
                            sortModel={this.state.sortModel}
                            onSortModelChange={this.handleSortModelChange}
                            pageSizeOptions={[10, 25, 50, 100]}
                        />
                    </div>
                    

                    {this.state.openSnack ? <SnackbarAlert severity={this.state.severity} message={this.state.message} /> : null}
                    {this.state.editarPrecioBarra ? <DialogEditarPrecioBarra fila={this.state.filaSeleccionada} refrescar={this.refrescar} handleClose={this.handleClose} /> : null}
                </div>
            );
        }
    }
}

export default RevisionPrecios;